module.exports = __webpack_public_path__ + "media/40.d2fa52c9.mp3";